<template lang="pug">
  div(class="upload-contact")
    div(class="upload-contact__header")
      h2(
        class="bold"
        :class="[xsDevice ? 'title-24px mb-5' : 'title-32px mb-8']"
      ) {{ $t(title) }}
      div(class="section__content")
        e-input-contact-upload(
          v-model="file"
          ref="fileInput"
        )
        div(class="two-buttons-wrapper pt-8")
          v-btn(
            height="48"
            @click="closeModal"
          ) {{ $t('Cancel') }}
          v-btn(
            class="main-button"
            @click="submit"
            :loading="isLoading"
          ) {{ $t('Import') }}
</template>

<script>
import Base64js from 'base64-js'
import { mapGetters } from 'vuex'
import responsive from '~/mixins/pages/responsive'
import EInputDocumentUpload from '~/modules/documents/components/elements/e-input-document-upload.vue'
import Contact from '~/modules/contacts/models/Contact'
import converters from '~/mixins/methods/converters'
import informationDialog from '~/mixins/dialogs/informationDialog'
import contentDialog from '~/mixins/dialogs/contentDialog'
import EInputContactUpload from '~/modules/contacts/components/e-input-contact-upload'

export default {
  name: 'MUploadContact',
  components: {
    EInputContactUpload,
    EInputDocumentUpload
  },
  mixins: [responsive, converters, informationDialog, contentDialog],
  props: {
    title: {
      type: String,
      default: ''
    },
    closeModal: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      file: null,
      isLoading: false
    }
  },
  computed: {
    ...mapGetters('contacts', ['params'])
  },
  methods: {
    async submit() {
      const fileInputValid = await this.$refs.fileInput?.validate()
      if (!fileInputValid.valid) return

      try {
        this.isLoading = true
        const arrayBuffer = await this.blobToArrayBuffer(this.file)
        const uint8View = new Uint8Array(arrayBuffer)
        const payload = { importFileContent: Base64js.fromByteArray(uint8View) }
        const response = await Contact.api().import(payload)
        const errors = this._.get(response, 'response.data.errors', [])
        await this.contentDialog.open({
          component: 'm-create-contact-errors',
          width: '512px',
          componentProps: {
            title: this.$t('Contacts imported'),
            success: this._.get(response, 'response.data.result.success', 0),
            failed: this._.get(response, 'response.data.result.failed', 0),
            errors
          }
        })
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        this.isLoading = false
        this.closeModal()
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
